import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "chat-message-timestamp-wrap"
}
const _hoisted_2 = { class: "chat-message-timestamp-text" }

import type { ChatItem } from '@/types/chat';
import { ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ChatMessage',
  props: {
    item: {}
  },
  setup(__props: any) {

const showTimestamp = ref(false);

const messageClick = () => {
  if (props.item.processing) return;

  // Timestamp does not make sense for note transcript messages at current moment.
  // TOOD(senad): refactor note transcript messages
  // showTimestamp.value = !showTimestamp.value;
};

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["chat-message-wrapper", [
      props.item.alignment === 'right' ? 'items-end' : 'items-start',
      { 'opacity-50': props.item.processing },
    ]])
  }, [
    (showTimestamp.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(props.item.timestamp), 1)
        ]))
      : _createCommentVNode("", true),
    _cache[0] || (_cache[0] = _createTextVNode()),
    _createElementVNode("div", {
      class: _normalizeClass(["chat-message-item", props.item.alignment === 'right' ? 'bg-standard-bg' : 'bg-selected-bg']),
      onClick: messageClick
    }, _toDisplayString(props.item.content), 3)
  ], 2))
}
}

})